var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallAnAmbulanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#DCB0BB",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6879 22.1387C22.6879 21.9585 22.6163 21.7859 22.4889 21.6585C22.3616 21.5311 22.1889 21.4595 22.0088 21.4595H10.5951C10.415 21.4595 10.2423 21.5311 10.115 21.6585C9.98759 21.7859 9.91602 21.9585 9.91602 22.1387V22.5999H22.6879L22.6879 22.1387Z",
    fill: "#A5334F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5122 21.0036H21.0911V15.758C21.0911 14.4877 20.5865 13.2695 19.6883 12.3713C18.7902 11.4731 17.5719 10.9685 16.3017 10.9685C15.0314 10.9685 13.8132 11.4731 12.915 12.3713C12.0168 13.2695 11.5122 14.4877 11.5122 15.758V21.0036Z",
    fill: "#A5334F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5542 9.46324L11.1014 8.91583L12.47 10.2842L11.9228 10.8316L10.5542 9.46324Z",
    fill: "#A5334F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1328 10.2842L21.5014 8.91583L22.0486 9.46324L20.68 10.8316L20.1328 10.2842Z",
    fill: "#A5334F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6751 12.6856L24.6104 12.6739L24.615 13.4479L22.6797 13.4596L22.6751 12.6856Z",
    fill: "#A5334F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38458 12.6856L10.3199 12.6739L10.3245 13.4479L8.38918 13.4596L8.38458 12.6856Z",
    fill: "#A5334F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9668 9.31151L16.0167 7.37684L16.7905 7.39692L16.7405 9.33159L15.9668 9.31151Z",
    fill: "#A5334F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallAnAmbulanceIcon);
export default __webpack_public_path__ + "static/media/callAnAmbulanceIcon.de79e9d930e27b365e2bed992e4f34c7.svg";
export { ForwardRef as ReactComponent };